import { useQuery } from "@tanstack/react-query";
import { fetchMultiChannel } from "../services/multiChannelService";

export function useMultiChannel(period: number) {
  return useQuery({
    queryKey: ["multi-channel", period],
    queryFn: () => fetchMultiChannel(period),
    staleTime: 1000 * 60 * 5, // 5 mins
  });
}
